import React, { useState, useEffect } from 'react'

import { IoMdAdd } from 'react-icons/io'

import { CardPercentageComponent } from '../../../../types/components'
import {
  ContentPercentage,
  ContentPercentageTop,
  ContentDescriptionPercentage,
  Add,
  CircularProgress,
  CircleWrapper,
  ProgressValue,
} from '../styles'

const Porcentage = ({ percentage, description }: CardPercentageComponent) => {
  const [progressValue, setProgressValue] = useState(0)
  const speed = 10

  useEffect(() => {
    const timer = setInterval(() => {
      setProgressValue((prevValue) => {
        if (prevValue >= percentage) {
          clearInterval(timer)
          return prevValue
        }
        return prevValue + 1
      })
    }, speed)

    return () => clearInterval(timer) // Limpiar el intervalo cuando el componente se desmonte
  }, [percentage, speed])

  return (
    <ContentPercentage>
      <ContentPercentageTop>
        <CircleWrapper>
          <CircularProgress $progress={progressValue}>
            <ProgressValue>{progressValue}%</ProgressValue>
          </CircularProgress>
        </CircleWrapper>
        <Add>
          <div>
            <IoMdAdd />
          </div>
        </Add>
      </ContentPercentageTop>
      <ContentDescriptionPercentage>
        <p>{description} </p>
      </ContentDescriptionPercentage>
    </ContentPercentage>
  )
}

export default Porcentage
